import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=3c7bf92e&"
import script from "./QuestionDialog.vue?vue&type=script&lang=js&"
export * from "./QuestionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports